
// export default Login;
import React, { useState } from 'react';
import axios from 'axios';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { motion } from 'framer-motion';
import logo from '../assets/logo-footer.png';
import './auth.css';
import Register from './Register';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const [success, setSuccess] = useState('');
    const [emailError, setEmailError] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [isLogin, setIsLogin] = useState(true);

    const location = useLocation();
    const message = location.state?.message;

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        setEmailError(e.target.value ? '' : 'البريد الإلكترونى مطلوب*');
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
        setPasswordError(e.target.value ? '' : 'كلمة المرور مطلوبة*');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        setSuccess('');
    
        try {
            const response = await axios.post('https://e-training.ivorytraining.com/api/ar/login', {
                email,
                password,
            });
    
            if (response.status === 200) {
                const token = response.data.data.token;
                const user = response.data.data.email;
                localStorage.setItem('token', token);
                localStorage.setItem('userEmail', user);
                localStorage.setItem('isLoggedIn', 'true');
                
                if (rememberMe) {
                    localStorage.setItem('token', token);
                    localStorage.setItem('userEmail', user);
                    localStorage.setItem('isLoggedIn', 'true');
                } else {
                    sessionStorage.setItem('token', token);
                    sessionStorage.setItem('isLoggedIn', 'true');
                }
    
                setTimeout(() => {
                    const referrer = document.referrer; 
                    if (referrer && !referrer.includes('/login') && !referrer.includes('/reset-password')) {
                        
                        window.location.href = referrer;
                    } else {
                       
                        window.location.href = '/';
                    }
                }, 1000);
            } else {
                setError('Invalid credentials');
            }
        } catch (error) {
            setError(' البيانات التى تم إدخالها غير صحيحه' || error.response?.data?.message);
        } finally {
            setLoading(false);
        }
    };
    

    return (
        <div className='login-section'>
            {message && <div className="alert alert-warning">{message}</div>}
            <div className="login row justify-content-between">
                <div className="right-section logoimg col-lg-7 col-md-6">
                    <Link to='/' className='image-part'>
                        <img src={logo} className='img-fluid w-100' alt="Logo" />
                    </Link>
                </div>
                <div className="form-part col-lg-5 col-md-6">
                    <div className='container'>
                        <div className="links">
                            <h3 className={isLogin ? "active" : ""} onClick={() => setIsLogin(true)}>تسجيل الدخول</h3>
                            <h3 className={!isLogin ? "active" : ""} onClick={() => setIsLogin(false)}>إنشاء حساب</h3>
                        </div>
                        <motion.div
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5 }}
                        >
                            {isLogin ? (
                                <form onSubmit={handleSubmit}>
                                    <p>مرحبــا بك</p>
                                    <h6>تسجيل الدخول</h6>
                                    <div>
                                        <label>البريد الإلكترونى</label><br />
                                        <input type="email" value={email} onChange={handleEmailChange} required
                                            placeholder={emailError}
                                        />

                                    </div>
                                    <div>
                                        <label>كلمة المرور</label><br />
                                        <div className="pass">
                                            <input
                                                type={showPassword ? "text" : "password"}
                                                value={password}
                                                onChange={handlePasswordChange}
                                                required
                                                placeholder={passwordError}
                                            />
                                            <FontAwesomeIcon
                                                icon={showPassword ? faEye : faEyeSlash}
                                                onClick={() => setShowPassword(!showPassword)}
                                                className="password-toggle-icon"
                                            />
                                        </div>

                                    </div>
                                    <label className='terms justify-content-between'>
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <input
                                                type="checkbox"
                                                checked={rememberMe}
                                                onChange={() => setRememberMe(!rememberMe)}
                                            />
                                            <span>تذكرنى</span>
                                        </div>
                                        <Link to='/forget'>نسيت كلمة المرور؟</Link>
                                    </label>
                                    {error && <p className="error-message">{error}</p>}
                                    {success && <p className="success-message">{success}</p>}
                                    <button type="submit" className="loginbtn" disabled={loading}>
                                        {loading ? 'جارٍ التحقق...' : 'تسجيل الدخول'}
                                    </button>
                                </form>
                            ) : (
                                <Register />
                            )}
                        </motion.div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
